import { required, requiredIf, email, sameAs } from "vuelidate/lib/validators";
import { password, phone, agreement } from "@/validation/";

const requirePassword = data => {
  return data.changePassword === true || data.changePassword === "1";
};

export default {
  user: {
    firstName: { required },
    lastName: { required },
    email: { required, email },
    phone: { required, phone },
    password: { required: requiredIf(requirePassword), password },
    passwordConfirm: {
      required: requiredIf(requirePassword),
      sameAsPassword: sameAs("password")
    },
    // acceptMarketing: { required },
    accept: { agreement }
  },
  login: {
    username: { required },
    password: { required }
  }
};
